module.exports = __webpack_public_path__ + "static/media/right_arrow.d548ad78.svg";